import type { Channel, Permission, Team } from '@nexo/types';

/** Whether the current user has a team-wide permission. */
export const can = (team: Pick<Team, 'permissions'>, permission: Permission): boolean =>
  team.permissions.includes(permission);

/** Whether the current user has a permission in a channel (always resolved by the server). */
export const canIn = (
  channel: Pick<Channel, 'permissions'> | null | undefined,
  permission: Permission,
): boolean => channel?.permissions.includes(permission) ?? false;
